export default {
  data() {
    return {
      editCrmField: {},
      crmFieldIsLoading: {},
      crmFieldValue: {},
      crmFieldSelectOptions: {},
      datetimeFormat: {
        stringify: (date) => {
          return date
            ? this.$moment(date).tz(this.teams[this.$route.params.team].account.timezone).format("L HH:mm")
            : null;
        },
        parse: (value) => {
          return value
            ? this.$moment(value, "L HH:mm").tz(this.teams[this.$route.params.team].account.timezone).toDate()
            : null;
        },
      },
    };
  },
  methods: {
    setEditableCrmFields(crmFields, obj) {
      let current = JSON.parse(JSON.stringify(obj));
      if (!current.crm) current.crm = {};
      Object.entries(crmFields).forEach(([key, field]) => {
        if (!field.readonly) {
          if (field.type === "select" || field.type === "multiselect") {
            const options = [];
            let label;
            field.config.options.forEach((option) => {
              option.label[this.teams[this.$route.params.team].account.locale]
                ? (label = option.label[this.teams[this.$route.params.team].account.locale])
                : (label = option.label.default);
              options.push({ label: label, value: option.value });
              if (field.type === "select") {
                if (current.crm[key] && current.crm[key][0] === option.value) {
                  this.$set(this.crmFieldValue, key, {
                    label: label,
                    value: option.value,
                  });
                }
              } else if (field.type === "multiselect") {
                if (!Array.isArray(this.crmFieldValue[key])) {
                  this.$set(this.crmFieldValue, key, []);
                }
                if (current.crm[key]) {
                  current.crm[key].forEach((o) => {
                    if (o === option.value) {
                      this.crmFieldValue[key].push({
                        label: label,
                        value: option.value,
                      });
                    }
                  });
                }
              }
            });
            this.$set(this.crmFieldSelectOptions, key, options);
          } else {
            if (field.type === "datetime") {
              current.crm[key] = this.$moment(current.crm[key])
                .tz(this.teams[this.$route.params.team].account.timezone)
                .toDate();
            }
            this.$set(this.crmFieldValue, key, current.crm[key]);
          }
          this.$set(this.editCrmField, key, false);
          this.$set(this.crmFieldIsLoading, key, false);
        }
      });
    },
    getCrmFieldTitle(crmField) {
      return this.$h.getLanguageValue(crmField.title);
    },
    getCrmFieldPlaceholder(crmField) {
      return this.$h.getLanguageValue(crmField.placeholder);
    },
    getCrmFieldValue(crmField, index, current) {
      if (current.crm) {
        const type = crmField.type;
        let value;
        switch (type) {
          case "datetime": {
            value = this.$h.formatDate(current.crm[index], this.teams[this.$route.params.team].account.timezone);
            break;
          }
          case "select": {
            const options = crmField.config.options;
            let option = null;
            if (current.crm[index] !== null && current.crm[index].length) {
              for (const v in current.crm[index]) {
                option = options.find((o) => {
                  return o.value === current.crm[index][v];
                });
              }
            }
            if (option) {
              value = this.$h.getLanguageValue(option.label);
            } else {
              value = "";
            }
            break;
          }
          case "multiselect": {
            const options = crmField.config.options;
            if (current.crm[index] !== null && current.crm[index].length) {
              value = "<ul>";
              for (const va in current.crm[index]) {
                const option = options.find((o) => {
                  return o.value === current.crm[index][va];
                });
                if (option) {
                  if (!value) {
                    value = "<li>" + this.$h.getLanguageValue(option.label) + "</li>";
                  } else {
                    value = value + "<li>" + this.$h.getLanguageValue(option.label) + "</li>";
                  }
                }
              }
              value = value + "</ul>";
            }
            break;
          }
          case "radio": {
            const options = crmField.config.options;
            if (current.crm[index] !== null) {
              const option = options.find((o) => {
                return o.value === current.crm[index];
              });
              if (option) {
                value = this.$h.getLanguageValue(option.label);
              }
            }
            break;
          }
          case "range": {
            const units = crmField.config.unit;
            if (current.crm[index] !== null) {
              let amount = current.crm[index];
              let unit = "";
              for (const u in units) {
                if (u <= amount) {
                  amount = amount * units[u].multiplier;
                  unit = this.$h.getLanguageValue(units[u].label);
                  value = amount + unit;
                } else {
                  break;
                }
              }
            }
            break;
          }
          default: {
            value = current.crm[index];
          }
        }
        return value;
      } else {
        return null;
      }
    },
  },
};
